import { TreeNode } from "../core/tree/tree.interface";

export interface AppInfoRequest {
    cache: boolean;
    storage: boolean;
    cookies: boolean;
}

export interface DarkModeResponse {
    logoPath: string;
}

export interface DateFormatsString {
    dateFormat: 'DD/MM/YYYY' | 'YYYY-MM-DD' | 'DD/MM/YY';
    dateTimeFormat: 'DD/MM/YYYY HH:mm:ss' | 'YYYY-MM-DDTHH:mm:ss.SSSZ' | 'DD/MM/YY HH:mm:ss' | 'YYYY-MM-DD';
}


export const SeverityTypes = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
} as const;

export type SeverityTypes = typeof SeverityTypes[keyof typeof SeverityTypes];

export const severityColorMap: Record<SeverityTypes, string> = {
    [SeverityTypes.success]: 'green', // verde
    [SeverityTypes.error]: 'red', // rosso
    [SeverityTypes.warning]: 'amber', // giallo
    [SeverityTypes.info]: 'primary'  // azzurro
};

export enum ApiErrorType {
    BadRequest = 'BadRequest',
    Unauthorized = 'Unauthorized',
    Forbidden = 'Forbidden',
    NotFound = 'NotFound',
    Conflict = 'Conflict',
    Unprocessable = 'Unprocessable',
    InternalServer = 'InternalServer'
}

export interface ApiError {
    type: ApiErrorType;
    message: string;
    details?: any;
    statusCode: number;
}


export const AppTreeModules: TreeNode[] = [{
    moduleId: 1,
    moduleCode: "gestione-utenti",
    name: "Gestione utenti",
    childOf: 0,
    route: "home/gestione-utenti",
    menulvl: 1,
    menuOrder: 1,
    icon: 'icon-users',
    children: []
  },
  {
    moduleId: 2,
    moduleCode: "clienti",
    name: "Clienti",
    childOf: 0,
    route: "home/clienti",
    menulvl: 1,
    menuOrder: 2,
    children: [],
    icon: 'icon-anagrafiche'
  },
  {
    moduleId: 3,
    moduleCode: "gestione-partite",
    name: "Avventure",
    childOf: 0,
    route: "home/partite",
    menulvl: 1,
    menuOrder: 3,
    children: [],
    icon: 'icon-gamepad'
  },
  {
    moduleId: 4,
    moduleCode: "missioni-esplorative",
    name: "Missioni esplorative",
    childOf: 0,
    route: "home/missioni-esplorative",
    menulvl: 1,
    menuOrder: 4,
    children: [],
    icon: 'icon-route'
  },
  {
    moduleId: 5,
    moduleCode: "poi",
    name: "POI",
    childOf: 0,
    route: "home/poi",
    menulvl: 1,
    menuOrder: 5,
    children: [],
    icon: 'icon-pin'
  }];

